/**
 * UTERIFIC waitlist form enhancement.
 *
 * Appends the selected "what brought you here" chip to the hidden `contact[tags]` field
 * so the choice is stored as a customer tag (`concern:<value>`). Without JavaScript the
 * form still posts the base tags.
 *
 * Also brings a freshly-posted footer form's success message into view, since Shopify
 * reloads the page after a customer form submission. A popup signup is left alone: the
 * popup reopens over wherever the page landed.
 */
function syncTags(form) {
  const tags = form.querySelector('[data-ut-tags]');
  if (!tags) return;
  const base = tags.dataset.utBaseTags || tags.value;
  const checked = form.querySelector('[data-ut-concern]:checked');
  tags.value = checked ? `${base}, concern:${checked.value}` : base;
}

function init(root = document) {
  root.querySelectorAll('.ut-waitlist__form').forEach((form) => {
    if (form.dataset.utReady) return;
    form.dataset.utReady = 'true';
    form.addEventListener('change', (event) => {
      if (event.target instanceof HTMLInputElement && event.target.hasAttribute('data-ut-concern')) {
        syncTags(form);
      }
    });
    form.addEventListener('submit', () => syncTags(form));
  });

  // Every customer form on the page reports the success, so pick the one the visitor
  // actually used. If the popup carries one it opens itself over the page, and nothing
  // should scroll; otherwise bring the footer's message into view.
  if (window.location.search.includes('customer_posted=true')) {
    const inPopup = root.querySelector('dialog .ut-waitlist__done');
    const done = root.querySelector('.ut-waitlist__done');
    if (inPopup) {
      inPopup.focus({ preventScroll: true });
    } else if (done) {
      done.scrollIntoView({ block: 'center', behavior: 'smooth' });
      done.focus({ preventScroll: true });
    }
  }
}

init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
